import { useAuth } from '@/lib/store';
import { api } from '@/lib/api/config';

interface SendEmailParams {
  subject: string;
  message: string;
}

export async function sendSupportEmail({ subject, message }: SendEmailParams): Promise<void> {
  const { username } = useAuth.getState();
  
  if (!username) {
    throw new Error('User not authenticated');
  }

  try {
    await api.post('/api/support/email', {
      username,
      subject,
      message,
    });
  } catch (error) {
    console.error('Error sending support email:', error);
    throw error;
  }
}